import { render, staticRenderFns } from "./InsertBank.vue?vue&type=template&id=99471dac"
import script from "./InsertBank.vue?vue&type=script&lang=js"
export * from "./InsertBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports